import Annotation from './components/Annotation';

export default Annotation;
